import {NgModule} from '@angular/core';
import {JointApplicationComponent} from "./joint-application/joint-application.component";
import {CommonModule} from "@angular/common";
import {SharedModule} from "../shared/shared.module";
import {MaterialModule} from "../shared/material.module";
import {StatusTrackerModule} from "../status-tracker/status-tracker.module";
import {FlexLayoutModule} from "@angular/flex-layout";
import {CoreModule} from "../core/core.module";
import {NgxMaskModule} from "ngx-mask";
import {GooglePlaceModule} from "ngx-google-places-autocomplete";
import {HttpClientModule} from "@angular/common/http";
import {MatDialogModule} from "@angular/material/dialog";
import {InvitationLandingPageComponent} from "./invitation/invitation-landing-page/invitation-landing-page.component";
import { SignupModule } from '../signup/signup.module';
import { ReviewModule } from '../review/review.module';
import {CreateInvitationComponent} from "./invitation/create-invitation/create-invitation.component";
import {
  ReviewCreatedInvitationComponent
} from "./invitation/create-invitation/review-created-invitation/review-created-invitation.component";
import {PersonalDetailsComponent} from "./invitation/create-invitation/personal-details/personal-details.component";

@NgModule({
  declarations: [
    JointApplicationComponent,
    InvitationLandingPageComponent,
    CreateInvitationComponent,
    ReviewCreatedInvitationComponent,
    PersonalDetailsComponent
  ],
  imports: [
    SignupModule,
    ReviewModule,
    CommonModule,
    SharedModule,
    MaterialModule,
    StatusTrackerModule,
    FlexLayoutModule,
    CoreModule,
    NgxMaskModule.forChild(),
    GooglePlaceModule,
    HttpClientModule,
    MatDialogModule
  ],
  exports: [
    JointApplicationComponent,
    InvitationLandingPageComponent
  ]
})
export class JointApplicationMaintenanceModule {
}
